import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { TotalRewardsPerkCategory } from "src/Pages/Company/TotalReward/models/TotalRewardsPerk.models";
import sortByField from "src/utils/jsHelpers/sortByField";
import { fetchPerksCategories, fetchPerkCategory, savePerkCategory } from ".";

export const useListTotalRewardsPerksCategories = (companyId: string) =>
  useQuery({
    queryKey: ["total-rewards-perk-category", "list", { companyId }],
    queryFn: async ({ signal }) =>
      fetchPerksCategories(
        {
          tenant: companyId,
        },
        { signal }
      ),
    initialData: [],
  });

export const useListTotalRewardsPerksCategoriesOptions = (companyId: string) =>
  useQuery({
    queryKey: ["total-rewards-perk-category", "options", { companyId }],
    queryFn: async ({ signal }) =>
      fetchPerksCategories(
        {
          tenant: companyId,
          pagination: false,
        },
        { signal }
      ),
    select: (data) =>
      sortByField(
        data.map((o) => ({
          label: o.name,
          value: o.id,
          status: o.status,
        })) || [],
        "label"
      ),
  });

export const useGetTotalRewardsPerkCategory = (perkCategoryId: string) =>
  useQuery({
    enabled: perkCategoryId !== "-1",
    queryKey: [
      "total-rewards-perk-category",
      "details",
      { id: perkCategoryId },
    ],
    queryFn: async ({ signal }) =>
      fetchPerkCategory(perkCategoryId, { signal }),
  });

export const useSaveTotalRewardsPerkCategory = (companyId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formData: TotalRewardsPerkCategory) =>
      savePerkCategory(formData.id, formData, companyId),
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["total-rewards-perk-category"],
        }),
      ]),
  });
};
